const { REACT_APP_SENTRY_ENV: environment = 'localhost' } = process.env
export const isProductionEnvironment = environment === 'production'
